export const isDevAuthBypassEnabled = () => {
    const appEnv = (process.env.REACT_APP_APP_ENV || '').toLowerCase()
    const nodeEnv = (process.env.NODE_ENV || '').toLowerCase()
    return appEnv === 'dev' || appEnv === 'development' || nodeEnv === 'development' || nodeEnv === 'dev'
}

